import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-floating-config',
  templateUrl: './floating-config.component.html',
  styleUrls: ['./floating-config.component.scss'],
})
export class FloatingConfigComponent implements OnInit {
  panelVisible = false;
  selectedDataSource = 'traditional';
  selectedCollectionMethod = 'group_intervals';

  @ViewChild('configPanel') configPanelRef!: ElementRef;
  @ViewChild('fabButton') fabButtonRef!: ElementRef;

  constructor() {}

  ngOnInit() {
    const storedDataSource = localStorage.getItem('data_source_charts');
    const storedCollectionMethod = localStorage.getItem(
      'collection_method_charts'
    );

    if (storedDataSource) {
      this.selectedDataSource = storedDataSource;
    } else {
      localStorage.setItem('data_source_charts', this.selectedDataSource);
    }

    if (storedCollectionMethod) {
      this.selectedCollectionMethod = storedCollectionMethod;
    } else {
      localStorage.setItem(
        'data_collection_method_charts',
        this.selectedCollectionMethod
      );
    }
  }

  togglePanel() {
    this.panelVisible = !this.panelVisible;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInsidePanel = this.configPanelRef?.nativeElement?.contains(
      event.target
    );
    const clickedFabButton = this.fabButtonRef?.nativeElement?.contains(
      event.target
    );

    if (!clickedInsidePanel && !clickedFabButton) {
      this.panelVisible = false;
    }
  }

  updateDataSource(newDataSource: string): void {
    this.selectedDataSource = newDataSource;
    localStorage.setItem('data_source_charts', newDataSource);

    // Interpolation only available for Timestream
    if (newDataSource !== 'timestream') {
      this.selectedCollectionMethod = 'group_intervals';
      localStorage.setItem('collection_method_charts', 'group_intervals');
    }
  }

  updateCollectionMethod(newCollectionMethod: string): void {
    this.selectedCollectionMethod = newCollectionMethod;
    localStorage.setItem('collection_method_charts', newCollectionMethod);
  }
}
